
<template>
    <div class="widget widget-product card blogs" v-if="blogs != '' && blogs != null">
        <header class="card-header">
            <h3 class="card-title">
                <span> بلاگ </span>
                <span style="">
                    <a v-if="baseInfo.IsShopBlog != null && baseInfo.ShopBlogName != null" target="_blank" :href="baseInfo.ShopBlogName" class="d-block d-sm-none">
                        <i class="fa fa-external-link btn-link-m" aria-hidden="true"></i>
                    </a>
                </span>
            </h3>
            <!--<a href="#" class="view-all">مشاهده همه</a>-->
        </header>
        <div class="blog-carousel owl-carousel owl-theme">
            <div style="position:relative" class="item  discount-box" v-for="(blog,index) in blogs">
                <div>
                    <!--<a v-bind:href="blog.ApplicationUrl + '/blog/Contents/Blogs?BlogGroupId='+(blog.BlogGroupId)" class="discount">{{blog.BlogGroupName }}</a>-->
                    <a v-bind:href="blog.ApplicationUrl + '/blog/Contents/SingleBlog?Id='+(blog.Id)+'&'+'Title='+(blog.Title)">
                        <img style="width: 200px;" :src="blog.PicPath" class="img-fluid" :alt="blog.Title.replace(/\s+/g, '-')" :title=" blog.Title.replace(/\s+/g, '-')" @error="imageLoadOnError">
                    </a>
                    <div class="post-title">
                        <a v-bind:href="blog.ApplicationUrl + '/blog/Contents/SingleBlog?Id='+(blog.Id)+'&'+'Title='+(blog.Title)">

                            {{ blog.Title }}
                        </a>
                    </div>

                </div>
            </div>

        </div>
    </div>
</template>


<script>
    export default {
        data() {
            return {

            }
        },
        computed: {
            blogs: function () {
                return this.$store.getters.readBlogs;
            },
            baseInfo: function () {
                return this.$store.getters.readBaseInfo;
            }
        },
        methods: {
            imageLoadOnError(event) {
                event.target.src = "/assets/img/no-slider-image-available.png";
            },
        }
    }
</script>

<style scoped>
    .blogs .product-carousel .item .post-title {
        height: auto;
        text-align: center;
        margin-right: 18px;
        margin-bottom: 0;
    }

    .blogs .discount-box .discount {
        top: 20px;
        right: 25px;
        background-color: #790000;
        padding-left: 10px;
        padding-right: 10px;
        width: fit-content;
        font-size: 15px;
    }

    .call {
        font-size: 13px;
    }

    .unAvailable {
        font-size: 14px;
    }

    .discount-box {
        position: relative;
    }

        .discount-box .discount {
            content: '';
            width: 55px;
            height: 35px;
            background-color: #ef5662;
            color: #fff;
            top: 20px;
            left: 15px;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            font-weight: bold;
            border-radius: 40px;
            z-index: 9999;
            font-size: 16px;
        }

    @media only screen and (min-width: 0px) and (max-width: 640px) {
        .discount-box .discount {
            width: 44px;
            height: 25px;
            top: 7px;
            left: 1px;
            font-size: 13px;
        }

        .widget-blog .blog-carousel .item .price del, .brand-slider .blog-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }

        .widget-blog .blog-carousel .item ins, .brand-slider .blog-carousel .item ins {
            color: #ef5661;
            font-size: 13px;
        }
    }

    @media only screen and (min-width: 641px) and (max-width: 640px) {
        .widget-blog .blog-carousel .item .price del, .brand-slider .blog-carousel .item .price del {
            color: #979898;
            font-size: 13px;
        }
    }
</style>
